export default __webpack_public_path__ + "static/media/Ten2.349fd648.jpeg";